import { render, staticRenderFns } from "./ResInfoCardL.vue?vue&type=template&id=53960134&scoped=true&lang=pug"
import script from "./ResInfoCardL.vue?vue&type=script&lang=js"
export * from "./ResInfoCardL.vue?vue&type=script&lang=js"
import style0 from "./ResInfoCardL.vue?vue&type=style&index=0&id=53960134&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53960134",
  null
  
)

export default component.exports